import { render } from "./ShipMap.vue?vue&type=template&id=b098f4d2&scoped=true"
import script from "./ShipMap.vue?vue&type=script&lang=js"
export * from "./ShipMap.vue?vue&type=script&lang=js"

import "./ShipMap.vue?vue&type=style&index=0&id=b098f4d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b098f4d2"]])

export default __exports__